import { AIR_QUALITY_DISPLAY_GROUP, AQUIFER_LEVEL_ENTITY, DEPTH_DISPLAY_GROUP, DEPTH_ENTITY, DFINAL_ENTITY, ELEVATION_DISPLAY_GROUP, ELEVATION_ENTITY, FEET_DISPLAY_GROUP, FLOW_DISPLAY_GROUP, H2S_ENTITY, LEVEL_ENTITY, PERCENTAGE_DISPLAY_GROUP, Q_FINAL_ENTITY, QCONTINUITY_ENTITY, QUANTITY_ENTITY, RAIN_DISPLAY_GROUP, RAIN_ENTITY, RELATIVE_HUMIDITY_ENTITY, SILT_ENTITY, TEMPERATURE_DISPLAY_GROUP, TEMPERATURE_ENTITY, V_FINAL_ENTITY, VELOCITY_DISPLAY_GROUP, VELOCITY_ENTITY } from "../constant";
import { SelectableGroup } from "./selectable";

export class Entities {
    public entityId: number;
    public entityName: string;
    public displayGroup: number;
    public displayGroupName: string;
    public entityDisplayNamepublic: string;
    public entityShortDisplayNamepublic: string;
    public storageUnitCategorypublic: string;
    public flowDataTypepublic: string;
    public totallingMethodpublic: string;
    public summaryMethodpublic: string;
    public readings: Array<Readings>;
    public displayGroupPrecendece: number;
    public isPreDefined?: boolean;
}

class Readings {
    public locationID: number;
    public customerID: number;
    public entityID: number;
    public timeTag: string;
    public reading: number;
    public quality: number;
}

export class ReplaceEntity {
    public oldEntity: number;
    public newEntity: number;
}

export class EntitySelectorObject {
    public groupName: string;
    public groupId: number;
    public entities: EntitySelectorEntity[];
}

export class EntitySelectorEntity {
    public id: number;
    public name: string;
    public isChecked?: boolean;
    public groupId?: number;
    public isANSR?: boolean;
}

export interface EntitySelectableGroup extends SelectableGroup {
    isANSR: boolean;
}

export interface LocationEntityDefaults {
    selectedEntities: EntitySelectableGroup[];
    selectedSGEntities: EntitySelectableGroup[];
}

export const USGS = 'USGS';

export const SILT_ENTITY_INFO: SelectableGroup = { id: SILT_ENTITY, name: 'SILT' };

export const DEFAULT_SELECTED_ENTITIES: EntitySelectableGroup[] = [
    { id: DEPTH_ENTITY, groupId: DEPTH_DISPLAY_GROUP, name: 'DEPTH', isChecked: true, isANSR: false },
    { id: VELOCITY_ENTITY, groupId: VELOCITY_DISPLAY_GROUP, name: 'VELOCITY', isChecked: true, isANSR: false },
    { id: QUANTITY_ENTITY, groupId: FLOW_DISPLAY_GROUP, name: 'QUANTITY', isChecked: true, isANSR: false },
    { id: RAIN_ENTITY, groupId: RAIN_DISPLAY_GROUP, name: 'RAIN', isChecked: true, isANSR: false },
];

export const DEFAULT_SELECTED_ECHO_ENTITIES: EntitySelectableGroup[] = [
    { id: DEPTH_ENTITY, groupId: DEPTH_DISPLAY_GROUP, name: 'DEPTH', isChecked: true, isANSR: false },
    { id: QUANTITY_ENTITY, groupId: FLOW_DISPLAY_GROUP, name: 'QUANTITY', isChecked: true, isANSR: false },
    { id: RAIN_ENTITY, groupId: RAIN_DISPLAY_GROUP, name: 'RAIN', isChecked: true, isANSR: false },
];

export const DEFAULT_SELECTED_EDGE_DX_ENTITIES: EntitySelectableGroup[] = [
    { id: DEPTH_ENTITY, groupId: DEPTH_DISPLAY_GROUP, name: 'DEPTH', isChecked: true, isANSR: false },
    { id: H2S_ENTITY, groupId: AIR_QUALITY_DISPLAY_GROUP, name: 'H2S', isChecked: true, isANSR: false },
    { id: TEMPERATURE_ENTITY, groupId: TEMPERATURE_DISPLAY_GROUP, name: 'TEMP', isChecked: true, isANSR: false },
    { id: RAIN_ENTITY, groupId: RAIN_DISPLAY_GROUP, name: 'RAIN', isChecked: true, isANSR: false },
    { id: RELATIVE_HUMIDITY_ENTITY, groupId: PERCENTAGE_DISPLAY_GROUP, name: 'RELATIVE HUMIDITY', isChecked: true, isANSR: false },
];

export const DEFAULT_SELECTED_EDGE_RL_ENTITIES: EntitySelectableGroup[] = [
    { id: DEPTH_ENTITY, groupId: DEPTH_DISPLAY_GROUP, name: 'DEPTH', isChecked: true, isANSR: false },
    { id: QUANTITY_ENTITY, groupId: FLOW_DISPLAY_GROUP, name: 'QUANTITY', isChecked: true, isANSR: false },
    { id: RAIN_ENTITY, groupId: RAIN_DISPLAY_GROUP, name: 'RAIN', isChecked: true, isANSR: false },
];

export const DEFAULT_SELECTED_EDGE_RL_ENTITIES_NO_PERMISSIONS: EntitySelectableGroup[] = [
    { id: DFINAL_ENTITY, groupId: DEPTH_DISPLAY_GROUP, name: 'DFINAL', isChecked: true, isANSR: false },
    { id: Q_FINAL_ENTITY, groupId: FLOW_DISPLAY_GROUP, name: 'QFINAL', isChecked: true, isANSR: false },
    { id: RAIN_ENTITY, groupId: RAIN_DISPLAY_GROUP, name: 'RAIN', isChecked: true, isANSR: false },
];

export const DEFAULT_SELECTED_ECHO_ENTITIES_NO_PERMISSIONS: EntitySelectableGroup[] = [
    { id: DFINAL_ENTITY, groupId: DEPTH_DISPLAY_GROUP, name: 'DFINAL', isChecked: true, isANSR: false },
    { id: Q_FINAL_ENTITY, groupId: FLOW_DISPLAY_GROUP, name: 'QFINAL', isChecked: true, isANSR: false },
    { id: RAIN_ENTITY, groupId: RAIN_DISPLAY_GROUP, name: 'RAIN', isChecked: true, isANSR: false },
];

export const DEFAULT_SELECTED_RAIN_ENTITIES: EntitySelectableGroup[] = [
    { id: RAIN_ENTITY, groupId: RAIN_DISPLAY_GROUP, name: 'RAIN', isChecked: true, isANSR: false },
];

export const DEFAULT_SELECTED_GENERIC_MONITOR_ENTITIES: EntitySelectableGroup[] = [
    { id: DEPTH_ENTITY, groupId: DEPTH_DISPLAY_GROUP, name: 'DEPTH', isChecked: true, isANSR: false },
        { id: VELOCITY_ENTITY, groupId: VELOCITY_DISPLAY_GROUP, name: 'VELOCITY', isChecked: true, isANSR: false },
    { id: QUANTITY_ENTITY, groupId: FLOW_DISPLAY_GROUP, name: 'QUANTITY', isChecked: true, isANSR: false },
    { id: RAIN_ENTITY, groupId: RAIN_DISPLAY_GROUP, name: 'RAIN', isChecked: true, isANSR: false },
];

export const DEFAULT_SELECTED_GENERIC_MONITOR_ENTITIES_NO_PERMISSIONS: EntitySelectableGroup[] = [
    { id: DFINAL_ENTITY, groupId: DEPTH_DISPLAY_GROUP, name: 'DFINAL', isChecked: true, isANSR: false },
        { id: V_FINAL_ENTITY, groupId: VELOCITY_DISPLAY_GROUP, name: 'VFINAL', isChecked: true, isANSR: false },
    { id: Q_FINAL_ENTITY, groupId: FLOW_DISPLAY_GROUP, name: 'QFINAL', isChecked: true, isANSR: false },
    { id: RAIN_ENTITY, groupId: RAIN_DISPLAY_GROUP, name: 'RAIN', isChecked: true, isANSR: false },
];

export const DEFAULT_FORESITE_SELECTED_ENTITIES: EntitySelectableGroup[] = [
    { id: RAIN_ENTITY, groupId: RAIN_DISPLAY_GROUP, name: 'RAIN', isChecked: true, isANSR: false },
    { id: DEPTH_ENTITY, groupId: DEPTH_DISPLAY_GROUP, name: 'DEPTH', isChecked: true, isANSR: false },
];

export const DEFAULT_ELEVATION_FORESITE_SELECTED_ENTITIES: EntitySelectableGroup[] = [
    { id: RAIN_ENTITY, groupId: RAIN_DISPLAY_GROUP, name: 'RAIN', isChecked: true, isANSR: false },
    { id: ELEVATION_ENTITY, groupId: ELEVATION_DISPLAY_GROUP, name: 'ELEVATION', isChecked: true, isANSR: false },
];

export const DEFAULT_SELECTED_ENTITIES_NO_PERMISSIONS: EntitySelectableGroup[] = [
    { id: DFINAL_ENTITY, groupId: DEPTH_DISPLAY_GROUP, name: 'DFINAL', isChecked: true, isANSR: false },
    { id: V_FINAL_ENTITY, groupId: VELOCITY_DISPLAY_GROUP, name: 'VFINAL', isChecked: true, isANSR: false },
    { id: Q_FINAL_ENTITY, groupId: FLOW_DISPLAY_GROUP, name: 'QFINAL', isChecked: true, isANSR: false },
    { id: RAIN_ENTITY, groupId: RAIN_DISPLAY_GROUP, name: 'RAIN', isChecked: true, isANSR: false },
];

export const DEFAULT_SELECTED_FLEX_ENTITIES: EntitySelectableGroup[] = [
    { id: DEPTH_ENTITY, groupId: DEPTH_DISPLAY_GROUP, name: 'DEPTH', isChecked: true, isANSR: false },
        { id: VELOCITY_ENTITY, groupId: VELOCITY_DISPLAY_GROUP, name: 'VELOCITY', isChecked: true, isANSR: false },
    { id: QUANTITY_ENTITY, groupId: FLOW_DISPLAY_GROUP, name: 'QUANTITY', isChecked: true, isANSR: false },
    { id: RAIN_ENTITY, groupId: RAIN_DISPLAY_GROUP, name: 'RAIN', isChecked: true, isANSR: false },
];

export const DEFAULT_SELECTED_FLEX_ENTITIES_NO_PERMISSIONS: EntitySelectableGroup[] = [
    { id: DFINAL_ENTITY, groupId: DEPTH_DISPLAY_GROUP, name: 'DFINAL', isChecked: true, isANSR: false },
        { id: V_FINAL_ENTITY, groupId: VELOCITY_DISPLAY_GROUP, name: 'VFINAL', isChecked: true, isANSR: false },
    { id: Q_FINAL_ENTITY, groupId: FLOW_DISPLAY_GROUP, name: 'QFINAL', isChecked: true, isANSR: false },
    { id: RAIN_ENTITY, groupId: RAIN_DISPLAY_GROUP, name: 'RAIN', isChecked: true, isANSR: false },
];


export const DEFAULT_SG_SELECTED_ENTITIES: EntitySelectableGroup[] = [
    { id: DEPTH_ENTITY, groupId: DEPTH_DISPLAY_GROUP, name: 'DEPTH', isChecked: true, isANSR: false },
    { id: VELOCITY_ENTITY, groupId: VELOCITY_DISPLAY_GROUP, name: 'VELOCITY', isChecked: true, isANSR: false },
];
export const DEFAULT_SG_SELECTED_ENTITIES_NO_PERMISSIONS: EntitySelectableGroup[] = [
    { id: DFINAL_ENTITY, groupId: DEPTH_DISPLAY_GROUP, name: 'DFINAL', isChecked: true, isANSR: false },
    { id: V_FINAL_ENTITY, groupId: VELOCITY_DISPLAY_GROUP, name: 'VFINAL', isChecked: true, isANSR: false },
];
export const USGS_SELECTED_ENTITIES: EntitySelectableGroup[] = [
    { id: RAIN_ENTITY, groupId: RAIN_DISPLAY_GROUP, name: 'RAIN', isChecked: true, isANSR: false },
    { id: LEVEL_ENTITY, groupId: FEET_DISPLAY_GROUP, name: 'LEVEL', isChecked: true, isANSR: false },
    { id: AQUIFER_LEVEL_ENTITY, groupId: FEET_DISPLAY_GROUP, name: 'AQUIFER LEVEL', isChecked: true, isANSR: false },
];
export const USGS_SELECTED_ENTITIES_NO_PERMISSIONS: EntitySelectableGroup[] = [
    { id: RAIN_ENTITY, groupId: RAIN_DISPLAY_GROUP, name: 'RAINFINAL', isChecked: true, isANSR: false },
    { id: LEVEL_ENTITY, groupId: FEET_DISPLAY_GROUP, name: 'LEVEL', isChecked: true, isANSR: false },
    { id: AQUIFER_LEVEL_ENTITY, groupId: FEET_DISPLAY_GROUP, name: 'AQUIFER LEVEL', isChecked: true, isANSR: false },
];
export const COMPOSITE_SELECTED_ENTITIES: EntitySelectableGroup[] = [
    { id: QCONTINUITY_ENTITY, groupId: FLOW_DISPLAY_GROUP, name: 'QContinuity', isChecked: true, isANSR: false },
];
export const COMPOSITE_SELECTED_ENTITIES_NO_PERMISSIONS: EntitySelectableGroup[] = [
    { id: Q_FINAL_ENTITY, groupId: FLOW_DISPLAY_GROUP, name: 'QFINAL', isChecked: true, isANSR: false },
];
